import { Component } from '@angular/core';

@Component({
  selector: 'app-appointment-success',
  standalone: true,
  imports: [],
  templateUrl: './appointment-success.component.html',
  styleUrl: './appointment-success.component.scss'
})
export class AppointmentSuccessComponent {

}
